export default {
  fields: {
    online_shop_domain: 'Oma verkkotunnus verkkokauppaa varten',
    online_shop_domain_hint:
      'Ravintolan omistama verkkotunnus, kuten order.pizzeria-mario.com — vain tilaamista varten; verkkosivulle tarvitaan eri verkkotunnus. Tallennuksen jälkeen lisättävät tietueet näytetään tässä.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
